module.exports = __webpack_public_path__ + "static/img/2-2.3441ae5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/2-2.jpg
// module id = ahi6
// module chunks = 0